import Big from "big.js";

export function isValid(a: any) {
  if (!a) return false;
  if (isNaN(Number(a))) return false;
  if (a === "") return false;
  return true;
}

export function formatHealthFactor(hf: any) {
  try {
    if (hf === "∞") return hf;

    if (!hf || !isValid(hf)) return "-";

    if (Big(hf).gt(10000)) return "∞";
    if (Number(hf) === -1) return "∞";
    return Big(hf).toFixed(2);
  } catch (error) {
    console.log("CATCH_formatHealthFactor:", error);
  }
}

export function formatLongText(
  text?: string,
  front: number = 4,
  ending: number = 2
) {
  if (!text) return text;
  if (text.length <= front + ending) {
    return text;
  }
  return `${text.slice(0, front)}...${text.slice(-ending)}`;
}

export function readClipboard() {
  try {
    return navigator.clipboard.readText();
  } catch (err) {
    console.log('read clipboard failed: %o', err);
  }
  return Promise.resolve('');
}


export function getProtocolIcon(protocal: any) {
  const ImageMapping = {
    infrared: "/images/dapps/infrared/infrared.svg",
    bex: "/images/dapps/bex.svg",
    kodiak: "/images/dapps/kodiak.svg",
    berps: "/images/dapps/infrared/berps.svg",
    aquabera: "/images/dapps/infrared/aquabera.png",
    hub: "/images/dapps/bex.svg"
  }
  // @ts-ignore
  return ImageMapping?.[protocal?.toLocaleLowerCase()] ?? "/images/dapps/dolomite.svg"
}

export const isVideoFile = (url: string) => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const fileExtMatch = pathname.match(/\.([^./?]+)(?:[?#]|$)/);
    if (!fileExtMatch) return false;

    const extension = fileExtMatch[1].toLowerCase();
    const videoExtensions = ['mp4', 'webm', 'ogg'];
    return videoExtensions.includes(extension);
  } catch (e) {
    const videoExtensions = ['.mp4', '.webm', '.ogg'];
    return videoExtensions.some(ext => url.toLowerCase().includes(ext));
  }
};


export function capitalize(str: string) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.substring(1);
}

export function clampStyle(styles: React.CSSProperties, baseWidth: number = 1544) {
  const _styles: any = {};
  Object.entries(styles).forEach(([key, value]) => {
    const _value = parseFloat(value);
    const _percent = Math.abs(_value) / baseWidth;
    if (_value < 0) {
      _styles[key] = `clamp(calc(var(--beratown-base-width) * -${_percent}), -${_percent * 100}vw, 1px)`;
    } else {
      _styles[key] = `clamp(1px, ${_percent * 100}vw, calc(var(--beratown-base-width) * ${_percent}))`;
    }
  });
  return _styles;
}

export function camelToKebab(str: string) {
  return str
    .replace(/([A-Z])/g, "-$1")
    .toLowerCase()
    .replace(/^-/, "");
}
